<template>
  <div>
    <h1>Coding Class-forløb</h1>
    <p v-if="currentPage.endsWith('/online-undervisning')">
      4 dage med spiludvikling fra A-Z! <br />
      Du skal i løbet af 4 dage lave dit helt eget computerspil i Scratch!
      <br />
      <br />
      På scratch.mit.edu skal du lære at programmere et spil. <br />
      På piskelapp.com skal du lære at tegne de karakterer, objekter og
      baggrunde, <br />
      som du senere skal have ind i dit eget spil på Scratch.
    </p>
    <ul class="days">
      <li>
        <router-link
          to="/online-undervisning/dag-1"
          :class="{ active: currentPage.endsWith('/dag-1') }"
          >Dag 1</router-link
        >
      </li>
      <li>
        <router-link
          to="/online-undervisning/dag-2"
          :class="{ active: currentPage.endsWith('/dag-2') }"
          >Dag 2</router-link
        >
      </li>
      <li>
        <router-link
          to="/online-undervisning/dag-3"
          :class="{ active: currentPage.endsWith('/dag-3') }"
          >Dag 3</router-link
        >
      </li>
      <li>
        <router-link
          to="/online-undervisning/dag-4"
          :class="{ active: currentPage.endsWith('/dag-4') }"
          >Dag 4</router-link
        >
      </li>
    </ul>
    <router-view style="padding-bottom: 35px" />
  </div>
</template>

<script>
export default {
  computed: {
    currentPage() {
      return this.$route.path;
    }
  }
};
</script>

<style>
ul.days li {
  display: inline-block;
  margin: 10px;
}
ul.days li a {
  display: block;
  background: #00ffd4;
  color: #000000;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  font-size: 20px;
}
ul.days li a.active {
  background: #ff00f9;
  color: #fff;
}

a.purp {
  margin: 10px auto;
  background: #5000ff;
  color: #ffffff;
  width: 300px;
  padding: 10px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  font-size: 15px;
}
.block > * {
  display: block;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/undervisning/index.vue